export default __webpack_public_path__ + "static/media/infra-10.7dcc15ac.webp";